import React, { forwardRef, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const InputPassword = forwardRef((props, ref) => {
  const { className, title, name, type, errors, ...rest } = props;
  const [isHidden, setIsHidden] = useState(true);

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {title && (
        <label htmlFor={name} className="text-sm text-wce-neutral-9">
          {title}
        </label>
      )}
      <span className={`relative flex items-center`}>
        <input
          className={`border border-wce-neutral-5 w-full
        px-3 py-2 rounded-xl`}
          ref={ref}
          name={name}
          type={isHidden ? "password" : "text"}
          minLength="8"
          {...rest}
        />
        <span
          className="absolute right-3 text-wce-neutral-7 cursor-pointer"
          onClick={() => setIsHidden(!isHidden)}
        >
          {isHidden ? (
            <AiOutlineEyeInvisible size={20} />
          ) : (
            <AiOutlineEye size={20} />
          )}
        </span>
      </span>
      {errors?.[name]?.message && (
        <span className="text-sm text-wce-pink-bright">
          {errors?.[name]?.message}
        </span>
      )}
    </div>
  );
});

export default InputPassword;
